import { render, staticRenderFns } from "./coomdsPackage.vue?vue&type=template&id=1ea2aff6&scoped=true"
import script from "./coomdsPackage.vue?vue&type=script&lang=ts"
export * from "./coomdsPackage.vue?vue&type=script&lang=ts"
import style0 from "./coomdsPackage.vue?vue&type=style&index=0&id=1ea2aff6&prod&lang=less&scoped=true"
import style1 from "./coomdsPackage.vue?vue&type=style&index=1&id=1ea2aff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea2aff6",
  null
  
)

export default component.exports